module.exports = __webpack_public_path__ + "static/media/snowflakes.c5a40d28.svg";